import React from "react";
import {
  SearchBox,
  CurrentRefinements,
  RefinementList,
  ClearRefinements,
  Configure,
} from "react-instantsearch-hooks-web";
import EventManagementAdmin from "./Eventmangement_AdminUI";

const EventManagement = () => {
  return (
    <div>
      {/* Fetch all filtered hits so Active/Past/Archived can be ordered
          before local pagination (upcoming events must appear on page 1). */}
      <Configure hitsPerPage={10000} />
      <div className="grid w-full grid-cols-5">
        <div className="col-span-1 ml-12 mr-4">
          <SearchBox
            placeholder="Search by title "
            classNames={{
              input: "w-full",
              submitIcon: "hidden",
              resetIcon: "hidden",
              submit: "hidden",
            }}
          />
          <CurrentRefinements />
          <div>
            <h2 className="mb-[-10px] mt-4 text-instant-teams-blue-Main">
              Filter by Status
            </h2>
          </div>
          <RefinementList
            attribute="status"
            operator="and"
            classNames={{
              root: "capitalize",
              showMore: " text-instant-teams-blue-Main text-xs",
            }}
            limit={5}
            showMore={false}
          />
          <div>
            <h2 className="mb-[-10px] text-instant-teams-blue-Main">
              Filter by Featured Status
            </h2>
          </div>
          <RefinementList
            attribute="featured"
            operator="and"
            classNames={{
              root: "capitalize",
              showMore: " text-instant-teams-blue-Main text-xs",
            }}
            limit={5}
            showMore={false}
          />
          <div>
            <h2 className="mb-[-10px] text-instant-teams-blue-Main">
              Filter by Type
            </h2>
          </div>
          <RefinementList
            attribute="post_type"
            operator="and"
            classNames={{
              root: "capitalize",
              showMore: " text-instant-teams-blue-Main text-xs",
            }}
            limit={5}
            showMore={false}
          />

          <ClearRefinements
            translations={{ resetButtonText: "Clear Filters" }}
            classNames={{
              button:
                " bg-instant-teams-teal-Main text-white p-2 rounded mt-5 text-center w-full",
            }}
          />
        </div>

        <div className="col-span-4 items-start">
          <div className="grid grid-cols-1">
            <EventManagementAdmin />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventManagement;
